/* eslint-disable @typescript-eslint/ban-ts-comment */
import { VueConstructor } from "vue";
import Router, { RawLocation, Route } from "vue-router";
import { Store } from "vuex";
import { ACTION_TYPES, MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import { getLoginData } from "@/lib/authHelper";
import emitter from "@/lib/emitter";
import HistoryManager from "@/lib/historyManager";
import { allowAccess as allowAccessHelper, archivedUser as archivedUserHelper } from "@/lib/loginHelpers";
import { setReferral } from "@/lib/referralHelpers";
import { getProfileUrl } from "@/lib/urlHelpers";
import { EVENTS } from "@/const";

export default {
  install(Vue: VueConstructor, { router, store }: { router: Router; store: Store<StateRoot> }) {
    const origReplace = router.replace;
    // @ts-expect-error
    router.replace = function (...args) {
      HistoryManager.setReplace();
      // @ts-expect-error
      return origReplace.call(this, ...args);
    };
    router.beforeEach(async (to, from, next) => {
      if (to.query.redirectPath) {
        store.commit(MUTATION_TYPES.SET_REDIRECT_PATH, to.query.redirectPath);
      }
      if (to.query.referral) {
        const referral = to.query.referral;
        const referralId = Array.isArray(referral)
          ? referral.find<string>((i): i is string => typeof i === "string") || ""
          : referral;
        setReferral(referralId);
        store.commit(MUTATION_TYPES.SET_REDIRECT_PATH, getProfileUrl(referralId));
      }
      let location: RawLocation | false | void;
      const loginPath = (route: Route) => !!route.meta?.login || route.name === "logout" || route.path === "/";
      if (!store.state.user && getLoginData()) {
        await store.dispatch(ACTION_TYPES.LOGIN, getLoginData());
      }
      const allowAccess = allowAccessHelper(store.state.user);
      const isArchivedUser = archivedUserHelper(store.state.user);
      const socialLogin = store.state.socialLogin;
      const loggedIn = !!store.state.user;
      const redirectPath = store.state.redirectPath;
      if (to.name === "loginToken") {
        next();
        return;
      } else if (to.matched.some(route => route.meta.private && !loggedIn)) {
        if (["profile", "profileById", "followersById", "followingById"].includes(to.name!)) {
          location = { name: "signup" };
        } else {
          location = { name: "login" };
        }
      } else if (to.name === "logout") {
        emitter.emit(EVENTS.AUDIO_PLAYER_RESET);
        await store.dispatch(ACTION_TYPES.LOGOUT);
        location = { name: "login" };
      } else if (loginPath(to) && loggedIn && allowAccess) {
        location = { name: "home" };
      } else if (to.name !== "signupAccountRestore" && loggedIn && !allowAccess && isArchivedUser) {
        location = { name: "signupAccountRestore" };
      } else if (to.name !== "signupEmailConfirm" && loggedIn && !allowAccess && socialLogin && !isArchivedUser) {
        location = { name: "signupEmailConfirm" };
      } else if (to.name !== "signupConfirm" && loggedIn && !allowAccess && !socialLogin && !isArchivedUser) {
        location = { name: "signupConfirm" };
      } else if (loginPath(from) && !loginPath(to) && loggedIn && allowAccess && redirectPath) {
        location = redirectPath;
      }

      if (!loginPath(to) && location && !redirectPath) {
        store.commit(MUTATION_TYPES.SET_REDIRECT_PATH, to);
      } else if (location === redirectPath) {
        store.commit(MUTATION_TYPES.SET_REDIRECT_PATH, null);
      }
      next(location);
    });
    router.afterEach(HistoryManager.afterEachGuard.bind(HistoryManager));
  },
};
